import { RTM_ME_GET } from 'containers/ConnectionManager/constants';

class GTMResolver {
  constructor(connection) {
    this.connection = connection;
  }

  getBearerInfo = () => this.connection.getBearerInfo();

  getCurrentUser = async () => {
    const responseMsg = await this.connection.fetch(RTM_ME_GET);
    return responseMsg.response.account;
  }
}

export default GTMResolver;
